import { mergeAttributes, Node } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'

import LabelAnnotationsDisplay from './labelAnnotationsDisplay.vue'

export default Node.create({
  name: 'LabelAnnotationsDisplay',

  group: 'inline',
  inline: true,
  atom: true,
  draggable: false,

  addAttributes() {
    return {
      labelid: {
        type: String,
        default: null,
      },
      annotationstext: {
        type: String,
        default: '',
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-type="label-annotations-display"]',
        attrs: {
          'data-type': 'label-annotations-display',
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes({
      ...HTMLAttributes,
      'data-type': 'label-annotations-display',
    })]
  },

  addNodeView() {
    return VueNodeViewRenderer(LabelAnnotationsDisplay)
  },
})